import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Box, BoxProps } from '@mui/material';

// ----------------------------------------------------------------------

interface Props extends BoxProps {
  disabledLink?: boolean;
}

export default function LogoSmall({ disabledLink = false, sx }: Props) {
  const logo = (
    <Box
      sx={{ width: 40, height: 40, ...sx }}
      className='flex justify-center items-center'
    >
      <svg
        width='37'
        height='42'
        viewBox='0 0 37 42'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M9.96881 14.951C6.1129 14.951 2.83462 17.7534 2.25206 21.5475L0.0547573 35.8581C-0.37866 38.6809 1.81603 41.2247 4.68481 41.2247H9.52908L12.3939 24.9703C22.941 24.9703 33.4258 23.7461 36.0511 14.951H9.96881Z'
          fill='#2196F3'
        />
        <path
          d='M3.79297 13.0357C3.79297 13.0357 5.57511 11.3106 7.83776 10.5794C9.84602 9.93038 12.2138 9.98001 12.2138 9.98001H36.7723C36.5956 4.49257 32.5572 0.775269 24.8815 0.775269H9.53985C7.19312 0.775269 5.20862 2.50393 4.89741 4.81921L3.79297 13.0357Z'
          fill='#66D4FF'
        />
      </svg>
    </Box>
  );

  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to='/'>{logo}</RouterLink>;
}
